import axios from "axios";
import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";

const Faq = () => {
  const FaqMain = [
    {
      id: "FaqItem1",
      eventKey: "0",
      faqtitle: "What is the admission process?",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem2",
      eventKey: "1",
      faqtitle: "How much dose admission cast?",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem3",
      eventKey: "2",
      faqtitle: "When admission season?",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem4",
      eventKey: "3",
      faqtitle: "Dose your institute accept regular or irregular students?",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem5",
      eventKey: "4",
      faqtitle: "Student transportation is available at your school",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem6",
      eventKey: "5",
      faqtitle: "Configure your business APIs",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem7",
      eventKey: "6",
      faqtitle: " Dose your institute accept regular or irregular students?",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
    {
      id: "FaqItem8",
      eventKey: "7",
      faqtitle: "When admission season?",
      faqtext:
        "You don't have to manually bill and send invoices anymore. Our Subscriptions management automates billing and sends tax-compliant invoices on your behalf.",
      faqlist1: "Set up billing frequencies and cycles",
      faqlist2: "Automate proration",
      faqlist3: "Bill across the globe and stay tax compliant",
      faqlist4: "Securely store customer credit card information",
    },
  ];
  const [faqSection, setFaqSection] = useState([]);
  useEffect(() => {
    axios.get("JSON/frequently.json").then((response) => {
      setFaqSection(response.data[0]);
    });
  }, []);
  return (
    <>
      <div className="faq-area">
        <div className="container">
          <div className="faq-area-wrapper">
            <div className="row">
              <div className="col-12">
                <div className="faq-area-inner">
                  <div className="row">
                    <div className="col-lg-6 col-md-8 col-12">
                      <div className="faq-top-content">
                        <h2 className="faq-top-content-title">
                          {faqSection?.section_title}
                        </h2>
                        <p className="faq-top-content-text">
                          {faqSection?.section_detail}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div>
                      <Accordion defaultActiveKey="0">
                        <div className="row">
                          {faqSection?.asked_questions?.map(
                            (FaqSingle, index) => (
                              <div
                                key={FaqSingle.id}
                                className="col-lg-6 col-12"
                              >
                                <Accordion.Item eventKey={index}>
                                  <Accordion.Header>
                                    {FaqSingle.questions}
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <div className="faq-main-body">
                                      <p className="faq-main-body-text">
                                        {FaqSingle.answer}
                                      </p>
                                      <ul className="faq-main-body-list">
                                        {FaqSingle?.nodes.map((node) => (
                                          <li key={node?.id}>
                                            {node?.nodeText}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </div>
                            )
                          )}
                        </div>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
